import { ExternalQuotePage } from 'external-quote/pages';

import { externalQuotePath } from './routePaths';

export const externalQuote = {
  path: externalQuotePath(),
  exact: true,
  isPrivate: true,
  element: <ExternalQuotePage />,
};
